module.exports = __webpack_public_path__ + "officialStatic/img/shiPinCode.bd71bf9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/shiPinCode.png
// module id = dSCI
// module chunks = 0